import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteEmailTemplatesFromAPI, fetchEmailTemplatesFromAPI, uploadEmailTemplateFileToAPI } from "../../../services/EmailTemplateService";


export const fetchEmailTemplates = createAsyncThunk(
  "emailTemplates/fetchEmailTemplates",
  async ({ page, perPage, search, columnFilters, sort }, { rejectWithValue }) => {
    try {
      const response = await fetchEmailTemplatesFromAPI(page, perPage, search, columnFilters, sort);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data email template");
    }
  }
);


export const deleteEmailTemplate = createAsyncThunk(
  "emailTemplates/deleteEmailTemplate",
  async (emailTemplateId, { rejectWithValue }) => {
    try {
      const response = await deleteEmailTemplatesFromAPI(emailTemplateId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data email template");
    }
  }
);

// Upload Email Template File
export const uploadEmailTemplateFile = createAsyncThunk(
  "emailTemplates/uploadEmailTemplateFile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await uploadEmailTemplateFileToAPI(formData);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error?.message || "Upload gagal.",
        detail: error?.detail || [],
        status: error?.status || "failed"
      });
    }
  }
);


const emailTemplateSlice = createSlice({
  name: "emailTemplates",
  initialState: {
    emailTemplates: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    totalCount: 0,
    active: 0,
    types: 0,
    loading: false,
    error: null,
    emailTemplateSearch: "",
    keywordSearch: "",
    columnFilters: {}
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = { ...state.columnFilters, ...action.payload };
    },
    resetEmailTemplateState: (state) => {
      state.emailTemplates = [];
      state.currentPage = 1;
      state.lastPage = 1;
      state.perPage = 10;
      state.firstItem = 1;
      state.totalCount = 0;
      state.loading = false;
      state.error = null;
      state.emailTemplateSearch = "";
      state.keywordSearch = "";
      state.columnFilters = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmailTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.emailTemplates = action.payload.data.emailTemplates || [];
        state.currentPage = action.payload.data.pagination?.current_page || 1;
        state.lastPage = action.payload.data.pagination?.last_page || 1;
        state.perPage = action.payload.data.pagination?.per_page || 10;
        state.firstItem = action.payload.data.pagination?.from || 1;
        state.totalCount = action.payload.data.pagination?.total || 0;
        state.active = action.payload.data.active ?? 0;
        state.types = action.payload.data.types ?? 0;
      })
      .addCase(fetchEmailTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteEmailTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteEmailTemplate.fulfilled, (state, action) => {
        state.loading = false;
        // Remove deleted email template from state
        state.emailTemplates = state.emailTemplates.filter(
          (emailTemplate) => emailTemplate.id !== action.payload.data.emailTemplate.id
        );
        state.totalCount = Math.max(0, state.totalCount - 1);
      })
      .addCase(deleteEmailTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(uploadEmailTemplateFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadEmailTemplateFile.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally refresh the list after successful upload
      })
      .addCase(uploadEmailTemplateFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setPage, setPerPage, setKeywordSearch, setColumnFilters, resetEmailTemplateState } = emailTemplateSlice.actions;
export default emailTemplateSlice.reducer;
